<template>
    <!-- 报表管理－入园人数汇总 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'inShopStatistics')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="日期">
                        <a-range-picker
                            style="width:282px"
                            format="YYYY/MM/DD"
                            v-decorator="['giveDate']"
                        />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>

            <div class="container">
                    
                <a-table
                    :bordered="true"
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    @change="changePage"
                    :rowKey="(record,index) => index"
                >
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex"
    const columns = [
        {
            title: "日期",
            dataIndex: "day"
        },
        {
            title: "人数",
            dataIndex: "verifyNum"
        },
    ];
    export default {
        name: "inShopStatistics",
        components: {},
        props: {},
        data() {
            return {
                dataSource: [],
                columns,
                // 分页
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
            };
        },
        watch: {
            $route: function(newVal, oldVal) {
                if (newVal.name === "inShopStatistics") {
                    this.getList();
                }
            },
            shopId() {
                this.getList();
            }
        },
        methods: {
            //重置
            handleReset() {
                this.form.resetFields();
                this.getList()
            },
            //筛选
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination = page;
                this.getList();
            },
            //获取列表 
            getList() {
                if(!this.shopId) return
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const rangeValue = values['giveDate'] || [];
                    delete values.giveDate;
                    this.$api.statement
                        .verifyNumDay({
                            body: {
                                shopId: this.shopId,
                                startDate: rangeValue.length > 0 ? rangeValue[0].format('YYYY-MM-DD') : undefined,
                                endDate: rangeValue.length > 0 ? rangeValue[1].format('YYYY-MM-DD') : undefined,
                                pageNum: this.pagination.current,
                                pageSize: this.pagination.pageSize
                            }
                        })
                        .then(res => {
                            this.dataSource = res || [];
                            this.pagination.total = this.dataSource.length;
                        });
                });
            },
        }, 
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList();
        },
        computed: {
            ...mapGetters(["shopId"])
        },
    };
</script>
<style lang="scss" scoped>
    .container {
        background: #fff;
    }
</style>